export const createEmptyFilter = () => ({ id: crypto.randomUUID(), type: null, value: {} })

export const haveFiltersChanged = (filters, snapshot) => {
  if (!snapshot) return true
  const activeFilters = filters.filter(f => f.type)
  const activeSnapshot = snapshot.filter(f => f.type)
  if (activeFilters.length !== activeSnapshot.length) return true

  return activeFilters.some((filter, i) => {
    const snap = activeSnapshot[i]
    return filter.type !== snap.type || JSON.stringify(filter.value) !== JSON.stringify(snap.value)
  })
}

export const getAvailableFilterTypes = (filters, filterId, filterTypes) => {
  const usedTypes = filters.filter(f => f.type && f.id !== filterId).map(f => f.type)
  return filterTypes.filter(ft => !usedTypes.includes(ft.value))
}
